import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-k', 'LetterK', [["path",{"d":"M9 7v5m0 0v5m0-5h.625m0 0 5.625 5m-5.625-5 5.625-5","key":"svg-0"}]]);